import { render } from "./Popup.vue?vue&type=template&id=381d5e37&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=381d5e37&lang=scss&scoped=true"

import exportComponent from "/Users/wojciechkasprzak/WWW/ilona-michal-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381d5e37"]])

export default __exports__